import { Slot } from "@radix-ui/react-slot";
import clsx from "clsx";
import { forwardRef, HTMLAttributes } from "react";
import { SpacingVariants } from "../../../types/spacing";
import classes from "./container.module.css";

export type ContainerRootProps = HTMLAttributes<HTMLDivElement> & {
  asChild?: boolean;
  size: "small" | "medium" | "large";
  gutter?: SpacingVariants;
};

export const Root = forwardRef<HTMLDivElement, ContainerRootProps>(
  ({ asChild, size, gutter, className, ...props }, ref) => {
    const Comp = asChild ? Slot : "div";

    const inlineStyle = {
      ...(gutter
        ? { "--container-min-gutter": `var(--container-gutter-${gutter})` }
        : null),
    };

    return (
      <Comp
        ref={ref}
        className={clsx(classes.root, classes[size], className)}
        style={inlineStyle as React.CSSProperties}
        {...props}
      />
    );
  },
);

Root.displayName = "ContainerRoot";

type ContainerBreakProps = HTMLAttributes<HTMLDivElement> & {
  asChild?: boolean;
  containContent?: boolean;
};

export const Break = forwardRef<HTMLDivElement, ContainerBreakProps>(
  ({ asChild, className, containContent, ...props }, ref) => {
    const Comp = asChild ? Slot : "div";

    return (
      <Comp
        ref={ref}
        className={clsx(
          classes.break,
          containContent && classes.breakContainContent,
          className,
        )}
        {...props}
      />
    );
  },
);

Break.displayName = "ContainerBreak";
